import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  Typography,
} from '@mui/material';
import { useCampaignCreation } from 'pages/AdCampaignPage/CampaignCreationContext';
import React from 'react';

type ContactRequestFormProps = {
  className?: string;
};

const ContactRequestForm: React.FC<ContactRequestFormProps> = ({
  className,
}) => {
  const {
    state: {
      values: { isTargetingContactRequest },
    },
    dispatch,
  } = useCampaignCreation();

  return (
    <FormGroup row={false} className={className}>
      <FormControlLabel
        key="contactRequest"
        label={
          <Typography variant="h3">
            Please contact me about additional targeting options
          </Typography>
        }
        control={
          <Checkbox
            checked={isTargetingContactRequest}
            onChange={() =>
              dispatch({
                type: 'CHANGE_CHECKBOX_VALUE',
              })
            }
          />
        }
      />
    </FormGroup>
  );
};
export default ContactRequestForm;
